import { IconType } from '@factorialco/f0-react'
import {
  Desktop,
  Headset,
  Keyboard,
  Laptop,
  Mobile,
  Mouse,
  Settings,
  Tablet,
} from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

export const ASSET_TYPES = [
  'laptop',
  'phone',
  'tablet',
  'desktop',
  'screen',
  'mouse',
  'keyboard',
  'headset',
  'other',
] as const

export type AssetType = (typeof ASSET_TYPES)[number]

export const ASSET_TYPE_ICONS: Record<AssetType, IconType> = {
  laptop: Laptop,
  phone: Mobile,
  tablet: Tablet,
  desktop: Desktop,
  screen: Desktop,
  mouse: Mouse,
  keyboard: Keyboard,
  headset: Headset,
  other: Settings,
} as const

export const getAssetTypeLabel = (type: AssetType): string => {
  switch (type) {
    case 'laptop':
      return i18n.t('it_management.assets.type.laptop')
    case 'phone':
      return i18n.t('it_management.assets.type.phone')
    case 'tablet':
      return i18n.t('it_management.assets.type.tablet')
    case 'desktop':
      return i18n.t('it_management.assets.type.desktop')
    case 'screen':
      return i18n.t('it_management.assets.type.screen')
    case 'mouse':
      return i18n.t('it_management.assets.type.mouse')
    case 'keyboard':
      return i18n.t('it_management.assets.type.keyboard')
    case 'headset':
      return i18n.t('it_management.assets.type.headset')
    case 'other':
      return i18n.t('it_management.assets.type.other')
    default:
      return type
  }
}

export interface AssetTypeOption {
  value: AssetType
  label: string
  icon: IconType
}

const getAssetTypeOptions = (): AssetTypeOption[] => {
  return ASSET_TYPES.map((type) => ({
    value: type,
    label: getAssetTypeLabel(type),
    icon: ASSET_TYPE_ICONS[type],
  }))
}

export const getAssetTypeSelectOptions = (): Array<{ value: AssetType; label: string }> => {
  return ASSET_TYPES.map((type) => ({
    value: type,
    label: getAssetTypeLabel(type),
  }))
}

export const getAssetTypeIcon = (type: string): IconType => {
  const normalizedType = type?.toLowerCase()
  switch (normalizedType) {
    case 'laptop':
      return ASSET_TYPE_ICONS.laptop
    case 'phone':
      return ASSET_TYPE_ICONS.phone
    case 'tablet':
      return ASSET_TYPE_ICONS.tablet
    case 'desktop':
      return ASSET_TYPE_ICONS.desktop
    case 'screen':
      return ASSET_TYPE_ICONS.screen
    case 'mouse':
      return ASSET_TYPE_ICONS.mouse
    case 'keyboard':
      return ASSET_TYPE_ICONS.keyboard
    case 'headset':
      return ASSET_TYPE_ICONS.headset
    case 'other':
      return ASSET_TYPE_ICONS.other
    default:
      return Settings
  }
}
